import React, { SFC } from 'react';

interface Props {
  size: 64 | 32 | 24 | 16;
}

export const Spinner: SFC<Props> = ({ size }) => (
  <span className="mx-spinner-ring" style={{ width: size, height: size }} />
);
